module.exports = __webpack_public_path__ + "static/img/select-img1.fb7af36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/select-img1.png
// module id = lclA
// module chunks = 1